export default "__VITE_ASSET__3fd75678__"